/**
 * MMI Case Type Enum
 * Defines the case types used in the PRO MMI Applicant Rating Form
 * Based on the 7 assessment categories for Multiple Mini Interviews
 */
export enum MMICaseType {
  COMMUNICATION_1 = "Communication - 1",
  COLLABORATION = "Collaboration",
  LEADERSHIP_HEALTH_ADVOCACY = "Leadership & Health Advocacy",
  COMMUNICATION_4 = "Communication - 4",
  SCHOLARSHIP = "Scholarship",
  PROFESSIONALISM = "Professionalism",
  ELIGIBILITY_VERIFICATION = "Eligibility Verification",
}

/**
 * Get all MMI case type values as an array
 */
export function getAllMMICaseTypes(): MMICaseType[] {
  return Object.values(MMICaseType);
}

/**
 * Check if a case type is valid
 */
export function isValidMMICaseType(caseType: string): caseType is MMICaseType {
  return Object.values(MMICaseType).includes(caseType as MMICaseType);
}

/**
 * Get display name for a case type
 */
export function getMMICaseTypeDisplayName(caseType: MMICaseType): string {
  return caseType;
}

/**
 * Get short code for a case type (for UI display)
 */
export function getMMICaseTypeShortCode(caseType: MMICaseType): string {
  const shortCodes: Record<MMICaseType, string> = {
    [MMICaseType.COMMUNICATION_1]: "COMM-1",
    [MMICaseType.COLLABORATION]: "COLLAB",
    [MMICaseType.LEADERSHIP_HEALTH_ADVOCACY]: "LEADER",
    [MMICaseType.COMMUNICATION_4]: "COMM-4",
    [MMICaseType.SCHOLARSHIP]: "SCHOLAR",
    [MMICaseType.PROFESSIONALISM]: "PROF",
    [MMICaseType.ELIGIBILITY_VERIFICATION]: "ELIGIB",
  };
  return shortCodes[caseType];
}

/**
 * Case type options for dropdowns
 */
export interface CaseTypeOption {
  label: string;
  value: MMICaseType;
  shortCode: string;
}

/**
 * Get all case types as dropdown options
 */
export function getCaseTypeOptions(): CaseTypeOption[] {
  return getAllMMICaseTypes().map(caseType => ({
    label: getMMICaseTypeDisplayName(caseType),
    value: caseType,
    shortCode: getMMICaseTypeShortCode(caseType),
  }));
}

